import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { mediaQueriesBP } from "@waytek/Utilities/variables";
import React, { FC } from "react";
import { css } from "styled-components";

export interface CartPageContainerStyles {
    headerContainer?: GridContainerProps;
    headerGridItem?: GridItemProps;
    cartLinesContainer?: InjectableCss;
    cartLinesGridItem?: GridItemProps;
    cartTotalGridItem?: GridItemProps;
    cartActionsGridItem?: GridItemProps;
    footerWrapper?: InjectableCss;
    backToTopButton?: ButtonPresentationProps;
}

export const cartPageContainerStyles: CartPageContainerStyles = {
    headerGridItem: {
        width: 12,
        css: css`
            ${mediaQueriesBP.minLG} {
                &&& {
                    margin-bottom: 18px;
                }
            }
        `,
    },
    cartLinesGridItem: {
        width: [12, 12, 12, 8, 8],
        css: css`
            flex-direction: column;
            ${mediaQueriesBP.minLG} {
                padding-right: 0;
            }
        `,
    },
    cartTotalGridItem: {
        width: [12, 12, 12, 4, 4],
        css: css`
            ${mediaQueriesBP.minLG} {
                padding-left: 40px;
            }

            ${mediaQueriesBP.maxLG} {
                display: flex;
                flex-direction: column;
            }

            [data-widget="Cart/CartTotal"] {
                height: 100%;
            }
        `,
    },
    cartActionsGridItem: {
        width: 12,
    },
    footerWrapper: {
        css: css`
            display: flex;
            justify-content: center;
            width: 100%;
        `,
    },
    backToTopButton: {
        variant: "secondary",
        css: css`
            margin-top: -8px;
        `,
    },
};

const styles = cartPageContainerStyles;

const CartPageContainer = ({ id }: WidgetProps) => {
    return (
        <>
            <GridContainer {...styles.headerContainer}>
                <GridItem {...styles.headerGridItem}>
                    <Zone zoneName="Content0" contentId={id} />
                </GridItem>
            </GridContainer>
            <GridContainer>
                <GridItem {...styles.cartLinesGridItem}>
                    <Zone zoneName="Content2" contentId={id} />
                    <CartFooter></CartFooter>
                </GridItem>
                <GridItem {...styles.cartTotalGridItem}>
                    <Zone zoneName="Content1" contentId={id} fullHeight={true} />
                </GridItem>
            </GridContainer>
        </>
    );
};

const CartFooter: FC = () => {
    const backToTopClickHandler = () => {
        const header = document.getElementById("cartHeader");
        if (header) {
            window.scrollTo(0, header.offsetTop);
        }
    };

    return (
        <StyledWrapper {...styles.footerWrapper}>
            <Button onClick={backToTopClickHandler} {...styles.backToTopButton}>
                {translate("Back to Top")}
            </Button>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: CartPageContainer,
    definition: {
        group: "Cart",
        allowedContexts: ["CartPage"],
        displayName: "Page Container",
    },
};

export default widgetModule;
